<template>
  <div>
    <a style="text-decoration: none" href="/admin?tab=bookings&status=Pending Cash Option">
      <v-alert outlined type="info">{{ pendingText }}</v-alert>
    </a>
  </div>
</template>

<script>
export default {
  name: "PendingCashPaymentRequests",
  props: {
    pendings: Array
  },
  computed: {
    pendingText() {
      return `${this.pendings.length} pending cash payment option request${this.pendings.length === 1 ? "" : "s"}.`
    },
  }
}
</script>